import { useSoftpayAppId } from '../context/SoftpayAppIdStore';
import { useMemo } from 'react';

export const useTerminalModeEnabled = (): boolean => {
  const appId = useSoftpayAppId();

  return useMemo(() => {
    return appId !== undefined;
  }, [appId]);
};
